var s={exports:{}};

export { s as __module };
//# sourceMappingURL=contact-channels145.js.map
